import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=c4ab4270&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports